import * as React from 'react'
import {Lang} from 'yougile-lang'

export const SearchHintNoQueryPredefined = () => (
  <div className="px-8 text-sm-regular text-secondary">
    <div className="p-8">{Lang.msg.searchResultsHint1}</div>
    <div className="p-8">
      <p>{Lang.msg.searchResultsHint2}</p>
      <ul className="ml-[1.25rem] mb-0">
        <li>{Lang.msg.searchResultsHint3}</li>
        <li>{Lang.msg.searchResultsHint4}</li>
        <li>{Lang.msg.searchResultsHint5}</li>
        <li>{Lang.msg.searchResultsHint6}</li>
      </ul>
    </div>
  </div>
)

export const SearchHintNoQueryCustom = () => (
  <div className="px-8 text-sm-regular text-secondary">
    <div className="p-8">{Lang.msg.searchResultsHint1}</div>
  </div>
)

export const SearchHintNothingFound = () => (
  <div className="px-8 text-sm-regular text-secondary">
    <div className="p-8">{Lang.msg.notFound}</div>
  </div>
)
